import "vite/modulepreload-polyfill";
import { createRoot } from "react-dom/client";
import { EventListWidget } from "./Components/EventList.jsx";

export function RenderEvents(configuration){
    const container = document.getElementById(configuration.container);
    const root = createRoot(container);

    root.render(
      (
        <EventListWidget configuration={configuration} />
      ),
    );
}

document.addEventListener("DOMContentLoaded", function() {
    const widget_configs = document.querySelectorAll(".event-list-widget-config");

    for (let config of widget_configs) {
        RenderEvents(JSON.parse(config.innerText));
    }
});
